function index (element, eventName) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var bubbles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var cancelable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var event;

  try {
    event = new CustomEvent(eventName, {
      bubbles: bubbles,
      cancelable: cancelable,
      detail: detail
    });
  } catch (e) {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, bubbles, cancelable, detail);
  }

  element.dispatchEvent(event);
}

export default index;
